class Slideshow {
	constructor($dom){
		this.list 		= $dom.querySelectorAll("li");
		this.current 	= 0;
		this.max 		= this.list.length;
		this.duration	= 3000;
		if( this.max > 1){
			this.start();
		}
	}
	start(){
		this.startTime	= kvSlide.getNow();
		this.check();
	}
	check(){
		let $this = this;
		let current = kvSlide.getNow();
		let diff = current - this.startTime;
		//console.log(diff);
		if( diff >= $this.duration ){
			$this.startTime = kvSlide.getNow();
			$this.inc();
		}else{
			setTimeout(function(){
				$this.check();
			}, 200);
		}
	}
	inc(){
		let $this = this;
		this.current++;
		if( $this.current >= $this.max ){
			$this.current = 0;
		}
		$this.change();
	}
	change(){
		let $this = this;
		//console.log(this.current, this.max);
		this.list.forEach( ($l, index) => {
			if( index === $this.current ){
				$l.classList.add("active");
			}else{
				if( $l.classList.contains("active") ){
					$l.classList.remove("active");
				}
			}
		});
		setTimeout(function(){
			$this.startTime = kvSlide.getNow();
			$this.check();
		}, 1000);
	}
}
export let kvSlide = {
	arry: [],
	init: function(){
		kvSlide.arry = null;
		kvSlide.arry = [];
		//console.log(kvSlide.arry);
		let $slideshows = document.querySelectorAll("[data-kv-slideshow]");
		if( $slideshows.length > 0 ){
			$slideshows.forEach( ($slide, index) => {
				kvSlide.arry[index] = new Slideshow($slide);
			});
			//console.log(kvSlide.arry);
		}
	},
	getNow: function(){
		let n = new Date();
		return n.getTime();
	}
}